import { mapProviderToConfig } from './config';
import type { ProviderConfig } from './types';

export const mapEmailToConfig = (email: string): ProviderConfig | undefined => {
  const [, domain] = email.split('@');
  const provider = domain?.split('.')[0];

  return mapProviderToConfig[provider];
};
